import {
  Box,
  Typography,
  Container,
  Link,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      component="footer"
      sx={{
        background: "#FFFFFF",
        py: 2,
        // borderTop: `1px solid ${theme.palette.primary.light}`,
      }}
    >
      <Container maxWidth="lg">
        {isMobile ? (
          // Mobile view - stacked layout
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#323B4B",
                fontWeight: "bold",
                fontSize: "0.875rem",
              }}
            >
              &copy; {new Date().getFullYear()} djoglo. All rights reserved.
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Link
                href="/term-conditions"
                sx={{
                  color: "#323B4B",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                  fontSize: "0.875rem",
                }}
              >
                {t("footer.terms")}
              </Link>
              <Link
                href="/privacy-policy"
                sx={{
                  color: "#323B4B",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                  fontSize: "0.875rem",
                }}
              >
                {t("footer.privacy")}
              </Link>
            </Box>
          </Box>
        ) : (
          // Desktop view - side by side
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{ color: "#323B4B", fontWeight: "bold", fontSize: "1rem" }}
            >
              &copy; {new Date().getFullYear()} djoglo. All rights reserved.
            </Typography>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Link
                href="/term-conditions"
                sx={{
                  color: "#323B4B",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("footer.terms")}
              </Link>
              <Link
                href="/privacy-policy"
                sx={{
                  color: "#323B4B",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("footer.privacy")}
              </Link>
            </Box>
          </Stack>
        )}
      </Container>
    </Box>
  );
}

export default Footer;
